module.exports = __webpack_public_path__ + "img/tab03.daa33e1a.png";